import { validateEmail } from '../../../../utils/validator';

const validate = (values, props) => {
  const isCompany = !!props.currentUser.company;

  const errors = {};
  if (!values.lastname) {
    errors.lastname = 'Champ requis';
  }
  if (!values.firstname) {
    errors.firstname = 'Champ requis';
  }
  if (!values.email) {
    errors.firstname = 'Champ requis';
  }
  if (values.email && !validateEmail(values.email)) {
    errors.email = 'Adresse email invalide';
  }
  if (isCompany) {
    if (!values.companyName) {
      errors.companyName = 'Champ requis';
    }
    if (!values.companyVatNumber) {
      errors.companyVatNumber = 'Champ requis';
    }
    if (!values.companyRegistrationNumber) {
      errors.companyRegistrationNumber = 'Champ requis';
    }
  }
  return errors;
};

export default validate;
